import React from 'react'
import PageTable from '../../../components/pageComponents/PageTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EditarCampana from './modales/EditarCamana';
import { faClipboardList, faEdit, faEye } from '@fortawesome/free-solid-svg-icons'
import DetalleCampana from './modales/DetalleCampana';
import ListaDeItemsPorCampana from "./modales/ListaDeItemsPorCampana";

const TableCampanha = ({
  formValues,
  setFormValues,
  setModalEnabled,
  paginator,
  setPaginator,
  keys: KEYS,
  isColaborador = false,
}) => {
  const rows = formValues.Items;

  const HEADERS = [
    { col: "col-md-3", label: "Campaña" },
    { col: "col-md-3", label: "Inicio" },
    { col: "col-md-3", label: "Fin" },
    { col: "col-md-1", label: "# Items" },
    { col: "", label: "Acciones" },
  ];

  return (
    <PageTable
      headers={HEADERS}
      paginator={paginator}
      setPaginator={setPaginator}>
      <tbody className="listar-tbody">
        {rows.map((row, i) => (
          <tr key={`${i}-${row.IdCampanaBeneficio}`}>
            <td>{row.Nombre}</td>
            <td className="text-center">{row.FechaInicio}</td>
            <td className="text-center">{row.FechaFin}</td>
            <td className="text-center">{row.NoItems}</td>
            <td className="text-center">
              <FontAwesomeIcon
                icon={faEdit}
                size="lg"
                className="hand-pointer generic-action-icon"
                title="Editar"
                onClick={() => {
                  setModalEnabled({
                    isEnable: true,
                    component: EditarCampana,
                    data: { IdCampanaBeneficio: row.IdCampanaBeneficio },
                  });
                }}
              />
              <FontAwesomeIcon
                icon={faEye}
                size="lg"
                className="hand-pointer generic-action-icon ml-2"
                title="Detalle"
                onClick={() => {
                  setModalEnabled({
                    isEnable: true,
                    component: DetalleCampana,
                    data: { IdCampanaBeneficio: row.IdCampanaBeneficio },
                  });
                }}
              />
              <FontAwesomeIcon
                icon={faClipboardList}
                size="lg"
                className="hand-pointer generic-action-icon ml-2"
                title="Asignar Ítems"
                onClick={() => {
                  setModalEnabled({
                    isEnable: true,
                    component: ListaDeItemsPorCampana,
                    data: { IdCampanaBeneficio: row.IdCampanaBeneficio },
                  });
                }}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </PageTable>
  );
};

export default TableCampanha;